module.exports = __webpack_public_path__ + "img/sign-in.0677177f.svg";